import {
  excludeClient,
  excludeProject,
  formatObjectRelation,
} from "@/common/utils";
import { HOSTS, ENDPOINTS } from "@/constants";
import { type AxiosResponse, httpClient } from "@/services/httpClient";
import type {
  Client,
  Place,
  Project,
  RootState,
  User,
  Variable,
} from "@/types";
import type { ParameterState } from "@/types/store";
import type { ActionTree } from "vuex";
import {
  ADD_PROJECT,
  ADD_PROJECT_SUCCESS,
  LOAD_CLIENT,
  LOAD_CLIENTS,
  LOAD_CLIENTS_FAILURE,
  LOAD_CLIENTS_SUCCESS,
  LOAD_CLIENT_FAILURE,
  LOAD_CLIENT_SUCCESS,
  LOAD_PLACE,
  LOAD_PLACES,
  LOAD_PLACES_FAILURE,
  LOAD_PLACES_SUCCESS,
  LOAD_PLACE_FAILURE,
  LOAD_PLACE_SUCCESS,
  LOAD_PROJECTS,
  LOAD_PROJECTS_SUCCESS,
  UPDATE_CLIENT,
  UPDATE_CLIENT_FAILURE,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_PLACE,
  UPDATE_PLACE_FAILURE,
  UPDATE_PLACE_SUCCESS,
  LOAD_VARIABLES,
  LOAD_VARIABLES_SUCCESS,
  LOAD_VARIABLES_FAILURE,
  LOAD_VARIABLE,
  LOAD_VARIABLE_SUCCESS,
  LOAD_VARIABLE_FAILURE,
  LOAD_VARIABLE_DATA,
  LOAD_VARIABLE_DATA_SUCCESS,
  LOAD_VARIABLE_DATA_FAILURE,
  LOAD_PROJECTS_FAILURE,
  EDIT_PROJECT,
  EDIT_PROJECT_SUCCESS,
  EDIT_PROJECT_FAILURE,
  ADD_PROJECT_FAILURE,
  LOAD_PROJECT,
  LOAD_PROJECT_SUCCESS,
  LOAD_PROJECT_FAILURE,
  LOAD_PROJECT_VARIABLES,
  LOAD_PROJECT_VARIABLES_SUCCESS,
  INIT_PROJECT_VARIABLES,
  EDIT_VARIABLE,
  EDIT_VARIABLE_SUCCESS,
  EDIT_VARIABLE_FAILURE,
  LOAD_USERS,
  LOAD_USERS_SUCCESS,
  LOAD_USERS_FAILURE,
  LOAD_USER,
  LOAD_USER_SUCCESS,
  LOAD_USER_FAILURE,
  LOAD_VARIABLES_BY_PROJECT_ID,
  LOAD_VARIABLES_BY_PROJECT_ID_SUCCESS,
  LOAD_VARIABLES_BY_PROJECT_ID_FAILURE,
  ADD_MANUAL_VARIABLE,
  ADD_MANUAL_VARIABLE_SUCCESS,
  ADD_MANUAL_VARIABLE_FAILURE,
  LOAD_MANUAL_VARIABLE,
  LOAD_MANUAL_VARIABLE_SUCCESS,
  LOAD_MANUAL_VARIABLE_FAILURE,
  EDIT_MANUAL_VARIABLE,
  EDIT_MANUAL_VARIABLE_SUCCESS,
  EDIT_MANUAL_VARIABLE_FAILURE,
  CLEAR_MANUAL_VARIABLE,
  LOAD_VARIABLE_RELATION,
  LOAD_VARIABLE_RELATION_SUCCESS,
  LOAD_VARIABLE_RELATION_FAILURE,
  LOAD_ALL_PROJECTS,
  LOAD_ALL_PROJECTS_SUCCESS,
  LOAD_ALL_PROJECTS_FAILURE,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  LOAD_ROLES,
  LOAD_ROLES_SUCCESS,
  LOAD_ROLES_FAILURE,
  LOAD_PERMISSIONS,
  LOAD_PERMISSIONS_SUCCESS,
  LOAD_PERMISSIONS_FAILURE,
  UPDATE_ROLES,
  UPDATE_ROLES_SUCCESS,
  UPDATE_ROLES_FAILURE,
  LOAD_AAPES,
  LOAD_AAPES_SUCCESS,
  LOAD_AAPES_FAILURE,
  ADD_AAPE,
  ADD_AAPE_SUCCESS,
  ADD_AAPE_FAILURE,
  EDIT_AAPE,
  EDIT_AAPE_SUCCESS,
  EDIT_AAPE_FAILURE,
  DELETE_AAPE,
  DELETE_AAPE_SUCCESS,
  DELETE_AAPE_FAILURE,
  CLEAR_AAPES,
  CLEAR_PERIMETERS,
  DELETE_PERIMETER,
  DELETE_PERIMETER_SUCCESS,
  DELETE_PERIMETER_FAILURE,
  EDIT_PERIMETER_FAILURE,
  EDIT_PERIMETER_SUCCESS,
  EDIT_PERIMETER,
  ADD_PERIMETER,
  ADD_PERIMETER_SUCCESS,
  ADD_PERIMETER_FAILURE,
  LOAD_PERIMETERS,
  LOAD_PERIMETERS_SUCCESS,
  LOAD_PERIMETERS_FAILURE,
  CLEAR_VARIABLE,
  RESET_VARIABLE_DATA,
  LOAD_PROJECT_VARIABLES_LOADING,
  LOAD_PROJECT_VARIABLES_END_LOADING,
  LOAD_AAPES_DETAIL_FAILURE,
  LOAD_AAPES_DETAIL_SUCCESS,
  LOAD_CHOICES_FAILURE,
  LOAD_CHOICES_SUCCESS,
  LOAD_CHOICES,
  LOAD_PROJECT_ENERGIES,
  LOAD_PROJECT_ENERGIES_FAILURE,
  LOAD_PROJECT_ENERGIES_SUCCESS,
  ADD_PROJECT_ENERGY,
  ADD_PROJECT_ENERGY_SUCCESS,
  ADD_PROJECT_ENERGY_FAILURE,
  EDIT_PROJECT_ENERGY,
  DELETE_PROJECT_ENERGY,
  DELETE_PROJECT_ENERGY_FAILURE,
  DELETE_PROJECT_ENERGY_SUCCESS,
  LOAD_BILANS,
  LOAD_BILANS_SUCCESS,
  LOAD_BILANS_FAILURE,
  DELETE_BILAN,
  DELETE_BILAN_SUCCESS,
  DELETE_BILAN_FAILURE,
  ADD_USER_SUCCESS,
  ADD_USER_FAILURE,
  UPDATE_ONE_USER_SUCCESS,
  UPDATE_ONE_USER_FAILURE,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  LOAD_BEX_SUPPORT,
  LOAD_BEX_SUPPORT_SUCCESS,
  LOAD_BEX_SUPPORT_FAILURE,
  LOAD_CHOICES_BEX_SUPPORT_SUCCESS,
  LOAD_CHOICES_BEX_SUPPORT_FAILURE,
  LOAD_CHOICES_BEX_SUPPORT,
  LOAD_BEX_SUPPORT_FILES_SUCCESS,
  LOAD_BEX_SUPPORT_FILES_FAILURE,
  LOAD_BEX_SUPPORT_FILES,
} from "./mutations";
import type { ProjectEnergy } from "@/types/common";
import {
  deleteBalanceAapeAndPerimeters,
  processBalanceAapes,
  processBalanceAapesPerimeters,
} from "@/common/project";

export const actions: ActionTree<ParameterState, RootState> = {
  // ROLES
  fetchRoles({ commit }) {
    commit(LOAD_ROLES);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.ROLES}`).then(
      (response: any) => {
        commit(LOAD_ROLES_SUCCESS, {
          roles: response.data,
          count: response.count,
        });
      },
      (error) => {
        commit(LOAD_ROLES_FAILURE, error.message);
      },
    );
  },

  updateRoles({ commit, dispatch }, params?: any) {
    commit(UPDATE_ROLES);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.ROLES}/${params.id}`, {
        ...params,
        id: undefined,
      })
      .then(
        (response: any) => {
          commit(UPDATE_ROLES_SUCCESS, response.data);
          dispatch("user/getCurrentUser", null, {
            root: true,
          });
        },
        (error) => {
          commit(UPDATE_ROLES_FAILURE, error.message);
        },
      );
  },

  // PERMISSIONS
  fetchPermissions({ commit }, params?: any) {
    commit(LOAD_PERMISSIONS);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.PERMISSIONS}`, {
        params: { ...params },
      })
      .then(
        (response: any) => {
          commit(LOAD_PERMISSIONS_SUCCESS, {
            permissions: response.data,
            count: response.count,
          });
        },
        (error) => {
          commit(LOAD_PERMISSIONS_FAILURE, error.message);
        },
      );
  },

  // USERS
  fetchUsers({ commit }, params?: any) {
    commit(LOAD_USERS);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.USER}`, {
        params: { ...params },
      })
      .then(
        (response: AxiosResponse<User[]>) => {
          commit(LOAD_USERS_SUCCESS, response.data);
        },
        (error) => {
          commit(LOAD_USERS_FAILURE, error.message);
        },
      );
  },

  // USER
  fetchUserById({ commit }, userId?: string) {
    commit(LOAD_USER);

    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.USER}/${userId}`).then(
      (response: AxiosResponse<User>) => {
        commit(LOAD_USER_SUCCESS, response.data);
      },
      (error) => {
        commit(LOAD_USER_FAILURE, error.message);
      },
    );
  },
  // Add a new user
  addUser({ commit }, user) {
    httpClient.post(`${HOSTS.AWS}/${ENDPOINTS.USER}`, user).then(
      (response) => {
        commit(ADD_USER_SUCCESS, response.data);
      },
      (error) => {
        commit(ADD_USER_FAILURE, error.message);
      },
    );
  },

  // Update an existing user
  updateOneUser({ commit, dispatch }, user) {
    httpClient.put(`${HOSTS.AWS}/${ENDPOINTS.USER}/${user.id}`, user).then(
      (response) => {
        commit(UPDATE_ONE_USER_SUCCESS, {
          ...response.data,
        });
        dispatch("user/getCurrentUser", null, {
          root: true,
        });
      },
      (error) => {
        commit(UPDATE_ONE_USER_FAILURE, error.message);
      },
    );
  },

  // Delete a user
  deleteUser({ commit }, userId) {
    httpClient.delete(`${HOSTS.AWS}/${ENDPOINTS.USER}/${userId}`).then(
      () => {
        commit(DELETE_USER_SUCCESS, userId);
      },
      (error) => {
        commit(DELETE_USER_FAILURE, error.message);
      },
    );
  },
  //CLIENTS
  fetchClients({ commit }, params?: any) {
    commit(LOAD_CLIENTS);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.CLIENTS}`, {
        params: { ...params },
      })
      .then(
        (response: AxiosResponse<Client[]>) => {
          commit(LOAD_CLIENTS_SUCCESS, excludeClient(response.data));
        },
        (error) => {
          commit(LOAD_CLIENTS_FAILURE, error.message);
        },
      );
  },

  //energy project
  fetchChoices({ commit }, params?: any) {
    commit(LOAD_CHOICES);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.CHOICES}`, {
        params: { ...params },
      })
      .then(
        (response: AxiosResponse<any[]>) => {
          commit(LOAD_CHOICES_SUCCESS, response.data);
        },
        (error) => {
          commit(LOAD_CHOICES_FAILURE, error.message);
        },
      );
  },
  //AAPES
  fetchAAPES({ commit }, params?: any) {
    commit(LOAD_AAPES);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.AAPE}`, {
        params: { ...params },
      })
      .then(
        (response: AxiosResponse<any[]>) => {
          commit(LOAD_AAPES_SUCCESS, response.data);
        },
        (error) => {
          commit(LOAD_AAPES_FAILURE, error.message);
        },
      );
  },
  fetchAAPEByID({ commit }, id: any) {
    commit(LOAD_AAPES);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.AAPE}/${id}`).then(
      (response: AxiosResponse<any[]>) => {
        commit(LOAD_AAPES_DETAIL_SUCCESS, response.data);
      },
      (error) => {
        commit(LOAD_AAPES_DETAIL_FAILURE, error.message);
      },
    );
  },
  addAAPE({ commit }, params?: any) {
    commit(ADD_AAPE);
    httpClient.post(`${HOSTS.AWS}/${ENDPOINTS.AAPE}`, params).then(
      (response: AxiosResponse<any>) => {
        commit(ADD_AAPE_SUCCESS, response.data);
      },
      (error) => {
        commit(ADD_AAPE_FAILURE, error.message);
      },
    );
  },

  editAAPE({ commit }, params?: any) {
    commit(EDIT_AAPE);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.AAPE}/${params?.id}`, {
        ...params,
        id: undefined,
      })
      .then(
        (response: AxiosResponse<any>) => {
          commit(EDIT_AAPE_SUCCESS, response.data);
        },
        (error) => {
          commit(EDIT_AAPE_FAILURE, error.message);
        },
      );
  },

  deleteAAPE({ commit }, params?: any) {
    commit(DELETE_AAPE);
    httpClient.delete(`${HOSTS.AWS}/${ENDPOINTS.AAPE}/${params?.id}`).then(
      () => {
        commit(DELETE_AAPE_SUCCESS, params);
      },
      (error) => {
        commit(DELETE_AAPE_FAILURE, error.message);
      },
    );
  },

  clearAAPES({ commit }) {
    commit(CLEAR_AAPES);
  },

  //PERIMETER
  fetchPerimeters({ commit }, params?: any) {
    commit(LOAD_PERIMETERS);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.PERIMETER}`, {
        params: { ...params },
      })
      .then(
        (response: AxiosResponse<any[]>) => {
          commit(LOAD_PERIMETERS_SUCCESS, response.data);
        },
        (error) => {
          commit(LOAD_PERIMETERS_FAILURE, error.message);
        },
      );
  },

  addPerimeter({ commit }, params?: any) {
    commit(ADD_PERIMETER);
    httpClient.post(`${HOSTS.AWS}/${ENDPOINTS.PERIMETER}`, params).then(
      (response: AxiosResponse<any>) => {
        commit(ADD_PERIMETER_SUCCESS, response.data);
      },
      (error) => {
        commit(ADD_PERIMETER_FAILURE, error.message);
      },
    );
  },
  addMainPerimeter({ commit, dispatch, state }, params?: any) {
    commit(ADD_PERIMETER);
    httpClient.post(`${HOSTS.AWS}/${ENDPOINTS.PERIMETER}`, params).then(
      (response: AxiosResponse<any>) => {
        commit(ADD_PERIMETER_SUCCESS, response.data);

        dispatch("editAAPE", {
          ...state.aapes.data[
            state.aapes.data.findIndex(
              (aape: any) => aape.id === params.aape.id,
            )
          ],
          mainPerimeter: {
            id: response.data.id,
          },
        });
      },
      (error) => {
        commit(ADD_PERIMETER_FAILURE, error.message);
      },
    );
  },
  editPerimeter({ commit }, params?: any) {
    commit(EDIT_PERIMETER);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.PERIMETER}/${params?.id}`, {
        ...params,
        id: undefined,
      })
      .then(
        (response: AxiosResponse<any>) => {
          commit(EDIT_PERIMETER_SUCCESS, response.data);
        },
        (error) => {
          commit(EDIT_PERIMETER_FAILURE, error.message);
        },
      );
  },

  deletePerimeter({ commit }, params?: any) {
    commit(DELETE_PERIMETER);
    httpClient.delete(`${HOSTS.AWS}/${ENDPOINTS.PERIMETER}/${params?.id}`).then(
      () => {
        commit(DELETE_PERIMETER_SUCCESS, params);
      },
      (error) => {
        commit(DELETE_PERIMETER_FAILURE, error.message);
      },
    );
  },

  clearPerimeters({ commit }) {
    commit(CLEAR_PERIMETERS);
  },

  //VARIABLE RELATION
  fetchVariableRelation({ commit }, params?: any) {
    commit(LOAD_VARIABLE_RELATION);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.OBJECT_RELATION}`, {
        params: { ...params },
      })
      .then(
        (response: AxiosResponse<any>) => {
          const relations = response.data.objects;
          if (relations[0]) {
            commit(
              LOAD_VARIABLE_RELATION_SUCCESS,
              formatObjectRelation(relations[0]),
            );
          }
        },
        (error) => {
          commit(LOAD_VARIABLE_RELATION_FAILURE, error.message);
        },
      );
  },

  //Client filter "fetch one client" by a request???
  fetchOneClient({ commit }, clientId?: string) {
    commit(LOAD_CLIENT);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.CLIENTS}`, {
        params: { clientId },
      })
      .then(
        (response: AxiosResponse<Client[]>) => {
          if (response.data.length === 1) {
            commit(LOAD_CLIENT_SUCCESS, response.data[0]);
          }
        },
        (error) => {
          commit(LOAD_CLIENT_FAILURE, error.message);
        },
      );
  },

  updateClient({ commit }, client: Client) {
    commit(UPDATE_CLIENT);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.CLIENTS}/${client?.id}`, {
        shortName: client.shortName,
      })
      .then(
        (response) => {
          commit(UPDATE_CLIENT_SUCCESS, response.data);
        },
        (error) => {
          commit(UPDATE_CLIENT_FAILURE, error.message);
        },
      );
  },

  //PLACES
  fetchPlaces({ commit }, params?: any) {
    commit(LOAD_PLACES);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.PLACES}`, {
        params: { ...params },
      })
      .then(
        (response: AxiosResponse<Place[]>) => {
          commit(LOAD_PLACES_SUCCESS, excludeClient(response.data));
        },
        (error) => {
          commit(LOAD_PLACES_FAILURE, error.message);
        },
      );
  },
  fetchOnePlace({ commit }, placeId?: string) {
    commit(LOAD_PLACE);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.PLACES}/${placeId}`).then(
      (response: AxiosResponse<Place[]>) => {
        commit(LOAD_PLACE_SUCCESS, response.data);
      },
      (error) => {
        commit(LOAD_PLACE_FAILURE, error.message);
      },
    );
  },
  initProjectVariables({ commit }) {
    commit(INIT_PROJECT_VARIABLES);
  },
  fetchVariablesByDevices({ commit }, params?: any) {
    commit(LOAD_PROJECT_VARIABLES, { id: params?.acquisitionDeviceId });
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.VARIABLES}`, {
        params: params,
      })
      .then((response: any) => {
        commit(LOAD_PROJECT_VARIABLES_SUCCESS, {
          id: params?.acquisitionDeviceId,
          children: response.data.map((variable: any) => ({
            name: variable.name,
            id: variable.id,
            type: variable.type,
          })),
        });
      });
  },

  fetchAllVariablesByDevices({ commit }, acquisitionDevices) {
    commit(LOAD_PROJECT_VARIABLES_LOADING);
    acquisitionDevices.forEach((device: any) => {
      commit(LOAD_PROJECT_VARIABLES, { id: device?.id });
    });
    Promise.all(
      acquisitionDevices.map((device: any) =>
        httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.VARIABLES}`, {
          params: {
            acquisitionDeviceId: device.id,
            limit: 1000,
            type: "variable",
          },
        }),
      ),
    ).then((response: any) => {
      response.forEach((rep: any, index: number) => {
        commit(LOAD_PROJECT_VARIABLES_SUCCESS, {
          id: acquisitionDevices[index]?.id,
          children: rep.data.map((variable: any) => ({
            name: variable.name,
            id: variable.id,
            type: variable.type,
          })),
        });
      });
      commit(LOAD_PROJECT_VARIABLES_END_LOADING);
    });
  },
  updateUser({ commit, dispatch }, payload: any) {
    commit(UPDATE_USER);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.USER}/${payload?.userId}`, {
        preferences: payload.preferences,
        favoriteProjects: payload.favoriteProjects,
        roles: payload.roles,
      })
      .then(
        (response: AxiosResponse<User[]>) => {
          commit(UPDATE_USER_SUCCESS, response.data);
          if (payload.isCurrentUser) {
            dispatch("user/editUser", response.data, {
              root: true,
            });
            dispatch("router/fetchClientPlaces", null, {
              root: true,
            });
          }
          if (payload.updateInterface) {
            location.reload();
          }
        },
        (error) => {
          commit(UPDATE_USER_FAILURE, error.message);
        },
      );
  },

  fetchVariablesByPlace({ commit }, params: any) {
    commit(LOAD_VARIABLES);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.VARIABLES}`, {
        params: {
          ...params,
        },
      })
      .then(
        (response: any) => {
          commit(LOAD_VARIABLES_SUCCESS, {
            variables: response.data.map((variable: any) => {
              return { ...variable, aggregationId: variable.aggregation.id };
            }),

            count: response.total_count,
          });
        },
        (error) => {
          commit(LOAD_VARIABLES_FAILURE, error.message);
        },
      );
  },

  updatePlace({ commit }, place: Place) {
    commit(UPDATE_PLACE);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.PLACES}/${place.id}`, {
        name: place.name,
        shortName: place.shortName,
        address: place.address,
        zipCode: place.zipCode,
        city: place.city,
        country: place.country,
        latitude: place.latitude,
        longitude: place.longitude,
        timezone: place.timezone,
      })
      .then(
        () => {
          commit(UPDATE_PLACE_SUCCESS, place);
        },
        (error) => {
          commit(UPDATE_PLACE_FAILURE, error.message);
        },
      );
  },
  fetchProjectsByPlace({ commit }, params?: any) {
    commit(LOAD_PROJECTS);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.PROJECT}`, {
        params: { ...params },
      })
      .then(
        (response: AxiosResponse<Project[]>) => {
          commit(LOAD_PROJECTS_SUCCESS, excludeProject(response.data));
        },
        (error) => {
          commit(LOAD_PROJECTS_FAILURE, error.message);
        },
      );
  },

  fetchOneProject({ commit }, params?: any) {
    commit(LOAD_PROJECT);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.PROJECT}/${params?.projectId}`)
      .then(
        (response: AxiosResponse<Project>) => {
          commit(LOAD_PROJECT_SUCCESS, response.data);
        },
        (error) => {
          commit(LOAD_PROJECT_FAILURE, error.message);
        },
      );
  },

  addProject({ commit, dispatch }, project: Project) {
    commit(ADD_PROJECT);
    httpClient.post(`${HOSTS.AWS}/${ENDPOINTS.PROJECT}`, project).then(
      (response: AxiosResponse<Project>) => {
        commit(ADD_PROJECT_SUCCESS, response.data);
        dispatch("router/fetchClientPlaces", null, {
          root: true,
        });
      },
      (error) => {
        commit(ADD_PROJECT_FAILURE, error.message);
      },
    );
  },

  updateProject({ commit }, project: Project) {
    commit(EDIT_PROJECT);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.PROJECT}/${project?.id}`, {
        ...project,
        id: undefined,
      })
      .then(
        (response: AxiosResponse<Project>) => {
          commit(EDIT_PROJECT_SUCCESS, response.data);
          // dispatch("router/fetchClientPlaces", null, {
          //   root: true,
          // });
        },
        (error) => {
          commit(EDIT_PROJECT_FAILURE, error.message);
        },
      );
  },
  async fetchBilanByProject(
    { commit, getters },
    {
      projectId,
      isRefresh = false,
      loadAll = false,
    }: {
      projectId: string;
      isRefresh: boolean;
      loadAll: boolean;
      contractEnergyTarget: any;
    },
  ) {
    try {
      commit(LOAD_BILANS);
      const response: AxiosResponse<any> = await httpClient.get(
        `${HOSTS.AWS}/${ENDPOINTS.BALANCEPROJECT}/${projectId}`,
      );
      let data = response.data;

      const aapes = getters.getAAPEDetail;
      data = await processBalanceAapes(data, aapes, loadAll);

      commit(LOAD_BILANS_SUCCESS, { bilans: data, isRefresh });
    } catch (error: any) {
      commit(LOAD_BILANS_FAILURE, error.message);
    }
  },
  async fetchBalancePerimeters(
    { getters },
    { bilan }: { projectId: string; bilan: any; contractEnergyTarget: any },
  ) {
    const aapes = getters.getAAPEDetail;
    await processBalanceAapesPerimeters(bilan, aapes);
    // const data =
    //commit(LOAD_BILANS_PERIMETERS_SUCCESS, { bilan: data, projectId });
  },
  async deleteBilan(
    { commit, state },
    { projectId, year }: { projectId: string; year: number },
  ) {
    try {
      commit(DELETE_BILAN);

      const bilan = state.bilans.data.find(
        (b: any) => b.project_id === projectId,
      );
      if (!bilan) {
        throw new Error("Bilan not found");
      }

      const balanceAapeToDelete = bilan.balanceAapes.find(
        (bAape: any) => bAape.year === year,
      );
      if (!balanceAapeToDelete) {
        throw new Error("BalanceAape not found");
      }

      await deleteBalanceAapeAndPerimeters(balanceAapeToDelete);

      commit(DELETE_BILAN_SUCCESS, { projectId, year });
    } catch (error: any) {
      commit(DELETE_BILAN_FAILURE, error.message);
    }
  },

  fetchProjecBexSupport({ commit }, id: any, isRerfresh = false) {
    commit(LOAD_BEX_SUPPORT);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.BEXSUPPORT}/${id}`).then(
      (response: AxiosResponse<any[]>) => {
        commit(LOAD_BEX_SUPPORT_SUCCESS, {
          project_id: id,
          bexSupport: response.data,
          isRerfresh: isRerfresh,
        });
      },
      (error) => {
        commit(LOAD_BEX_SUPPORT_FAILURE, error.message);
      },
    );
  },

  // Fetch Files
  fetchProjecBexSupportFiles({ commit }, id: any) {
    commit(LOAD_BEX_SUPPORT_FILES);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.BEXSUPPORT}/files`, {
        params: { projectId: id },
      })
      .then(
        (response: AxiosResponse<any[]>) => {
          commit(LOAD_BEX_SUPPORT_FILES_SUCCESS, {
            project_id: id,
            bexSupportFiles: response.data,
          });
        },
        (error) => {
          commit(LOAD_BEX_SUPPORT_FILES_FAILURE, error.message);
        },
      );
  },
  //energy project
  fetchBexChoices({ commit }, params?: any) {
    commit(LOAD_CHOICES_BEX_SUPPORT);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.BEXSUPPORT}/choices`, {
        params: { ...params },
      })
      .then(
        (response: AxiosResponse<any[]>) => {
          commit(LOAD_CHOICES_BEX_SUPPORT_SUCCESS, response.data);
        },
        (error) => {
          commit(LOAD_CHOICES_BEX_SUPPORT_FAILURE, error.message);
        },
      );
  },
  fetchProjectEnergy({ commit }, id: any) {
    commit(LOAD_PROJECT_ENERGIES);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.PROJECT_ENERGY}`, {
        params: { projectId: id },
      })
      .then(
        (response: AxiosResponse<ProjectEnergy[]>) => {
          commit(LOAD_PROJECT_ENERGIES_SUCCESS, response.data);
        },
        (error) => {
          commit(LOAD_PROJECT_ENERGIES_FAILURE, error.message);
        },
      );
  },

  addProjectEnergy({ commit }, projectenergy: ProjectEnergy) {
    commit(ADD_PROJECT_ENERGY);
    httpClient
      .post(`${HOSTS.AWS}/${ENDPOINTS.PROJECT_ENERGY}`, projectenergy)
      .then(
        (response: AxiosResponse<Project>) => {
          commit(ADD_PROJECT_ENERGY_SUCCESS, response.data);
        },
        (error) => {
          commit(ADD_PROJECT_ENERGY_FAILURE, error.message);
        },
      );
  },

  updateProjectEnergy({ commit, dispatch }, projectenergy: any) {
    commit(EDIT_PROJECT_ENERGY);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.PROJECT_ENERGY}/${projectenergy?.id}`, {
        ...projectenergy,
      })
      .then(() => {
        dispatch("parameter/fetchProjectEnergy", projectenergy.projectId, {
          root: true,
        });
      });
  },
  deleteProjectEnergy({ commit }, projectenergy?: any) {
    commit(DELETE_PROJECT_ENERGY);
    httpClient
      .delete(`${HOSTS.AWS}/${ENDPOINTS.PROJECT_ENERGY}/${projectenergy?.id}`)
      .then(
        () => {
          commit(DELETE_PROJECT_ENERGY_SUCCESS, projectenergy);
        },
        (error) => {
          commit(DELETE_PROJECT_ENERGY_FAILURE, error.message);
        },
      );
  },
  updateVariable({ commit }, variable: Variable) {
    commit(EDIT_VARIABLE);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.VARIABLES}/${variable?.id}`, {
        ...variable,
        id: undefined,
      })
      .then(
        (response: AxiosResponse<Variable>) => {
          commit(EDIT_VARIABLE_SUCCESS, response.data);
        },
        (error) => {
          commit(EDIT_VARIABLE_FAILURE, error.message);
        },
      );
  }, // preview variable
  loadVariableDatas({ commit }, params: any) {
    commit(LOAD_VARIABLE_DATA);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.GRAPH_DATA}`, {
        params: {
          id: params.variableId,
          aggregationId: params.aggregationId,
          preferredSampling: params.sampling,
          preferredSamplingUnit: params.samplingUnit,
          start: params.periode[0],
          end: params.periode[1],
          limit: 10000,
          timeserie: true,
          type: "variable",
        },
      })
      .then(
        (response: AxiosResponse<any>) => {
          commit(LOAD_VARIABLE_DATA_SUCCESS, {
            ...params.variable,
            data: response.data.data,
            unit: response.data.unit.name,
            preferredSampling: response.data.sampling,
            preferredSamplingUnit: response.data.samplingUnit,
            start: response.data.start,
            end: response.data.end,
          });
        },
        (error) => {
          commit(LOAD_VARIABLE_DATA_FAILURE, error.message);
        },
      );
  },
  fetchVariableById({ commit }, variableId?: string) {
    commit(LOAD_VARIABLE);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.VARIABLES}/${variableId}`).then(
      (response: AxiosResponse<Variable>) => {
        commit(LOAD_VARIABLE_SUCCESS, response.data);
      },
      (error) => {
        commit(LOAD_VARIABLE_FAILURE, error.message);
      },
    );
  },
  loadProjects({ commit }, placeId: string) {
    commit(LOAD_PROJECTS);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.PROJECT}`, {
        params: { placeId },
      })
      .then(
        (response: AxiosResponse<Project[]>) => {
          commit(LOAD_PROJECTS_SUCCESS, response.data);
        },
        (error) => {
          commit(LOAD_PROJECTS_FAILURE, error.message);
        },
      );
  },

  loadAllProjects({ commit }, params: string) {
    commit(LOAD_ALL_PROJECTS);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.PROJECT}`, {
        params: params,
      })
      .then(
        (response: AxiosResponse<Project[]>) => {
          commit(LOAD_ALL_PROJECTS_SUCCESS, response.data);
        },
        (error) => {
          commit(LOAD_ALL_PROJECTS_FAILURE, error.message);
        },
      );
  },

  fetchVariableByProject({ commit }, params?: any) {
    commit(LOAD_VARIABLES_BY_PROJECT_ID);
    httpClient
      .get(`${HOSTS.AWS}/${ENDPOINTS.VARIABLES}`, {
        params: {
          ...params,
        },
      })
      .then(
        (response: any) => {
          commit(LOAD_VARIABLES_BY_PROJECT_ID_SUCCESS, {
            variables: response.data.map((variable: any) => {
              return { ...variable, aggregationId: variable.aggregation.id };
            }),
            count: response.total_count,
          });
        },
        (error) => {
          commit(LOAD_VARIABLES_BY_PROJECT_ID_FAILURE, error.message);
        },
      );
  },

  addManualVariable({ commit }, variable: any) {
    commit(ADD_MANUAL_VARIABLE);
    httpClient.post(`${HOSTS.AWS}/${ENDPOINTS.VARIABLES}`, variable).then(
      (response: AxiosResponse<Variable>) => {
        commit(ADD_MANUAL_VARIABLE_SUCCESS, response.data);
      },
      (error) => {
        commit(ADD_MANUAL_VARIABLE_FAILURE, error.message);
      },
    );
  },
  fetchManualVariable({ commit }, variableId?: string) {
    commit(LOAD_MANUAL_VARIABLE);
    httpClient.get(`${HOSTS.AWS}/${ENDPOINTS.VARIABLES}/${variableId}`).then(
      (response: AxiosResponse<Variable>) => {
        commit(LOAD_MANUAL_VARIABLE_SUCCESS, response.data);
      },
      (error) => {
        commit(LOAD_MANUAL_VARIABLE_FAILURE, error.message);
      },
    );
  },
  editManualVariable({ commit }, variable: any) {
    commit(EDIT_MANUAL_VARIABLE);
    httpClient
      .put(`${HOSTS.AWS}/${ENDPOINTS.VARIABLES}/${variable.id}`, {
        ...variable,
        id: undefined,
      })
      .then(
        (response: AxiosResponse<Variable>) => {
          commit(EDIT_MANUAL_VARIABLE_SUCCESS, response.data);
        },
        (error) => {
          commit(EDIT_MANUAL_VARIABLE_FAILURE, error.message);
        },
      );
  },
  clearManualVariable({ commit }) {
    commit(CLEAR_MANUAL_VARIABLE);
  },
  clearVariable({ commit }) {
    commit(CLEAR_VARIABLE);
  },
  resetVariableData({ commit }) {
    commit(RESET_VARIABLE_DATA);
  },
};
